import * as React from 'react';
import './styles.css';
import { IProject, Map } from '../../../@types/models/Project';
import Image from '../Image';

export interface ProjectProps {
    map: Map;
    getProject: (uid: string) => Promise<IProject>;
}

interface ProjectState {
    project?: IProject;
}

export class Project extends React.Component<ProjectProps, ProjectState> {

    componentDidMount() {
        this.props.getProject(this.props.map.uid).then((project) => {
            this.setState(prev => ({ project: project }));
        });
    }
    render() {
        const project = this.state && this.state.project;
        return (
            <div className="project">
                {project &&
                    <Image 
                        src={`${project.Images.Src}`}
                        width={project.Images.Width}
                        alt={`${project.Title} image`}

                        className="project__image"
                    />
                }
                {project &&
                    <div className="project__captions" onClick={(e) => e.stopPropagation()}>
                        <div dangerouslySetInnerHTML={{ __html: project.Captions }}/>
                        {project.File &&
                            <a className="project__pdf-link" href={project.File.Src} target="_blank">
                                Read the related PDF
                            </a>}
                    </div>
                }
            </div>);
    }
}

export default Project;


// WEBPACK FOOTER //
// ./src/components/Project/Component.tsx